import { render, staticRenderFns } from "./UserPasswordRemind.vue?vue&type=template&id=637b7542&"
import script from "./UserPasswordRemind.vue?vue&type=script&lang=js&"
export * from "./UserPasswordRemind.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports